import { render, staticRenderFns } from "./checkbox-text.vue?vue&type=template&id=795e8df2&scoped=true"
import script from "./checkbox-text.vue?vue&type=script&lang=ts"
export * from "./checkbox-text.vue?vue&type=script&lang=ts"
import style0 from "./checkbox-text.vue?vue&type=style&index=0&id=795e8df2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795e8df2",
  null
  
)

export default component.exports